import React, { useState,useEffect,useContext,useRef  } from "react";
import { Box, Grid, Button } from "@mui/material";
import PatientInformation from "./tables/PatientInformation";
import Diagnoses from "./tables/Diagnoses";
import Allergies from "./tables/Allergies";
import Habits from "./tables/Habits";
import { CarePlanContext } from "../../../../context/CarePlanContext/CarePlanContext";
import { useTranslation } from "react-i18next";

export default function CarePlanElements({ patientId, onOpenModal, onCreatePlan }) {

  const { t } = useTranslation();
  const { createFullCarePlan } = useContext(CarePlanContext);

  const [standardCarePlanIds, setStandardCarePlanIds] = useState([]);

  const diagnosesRef = useRef();

  const handleCreatePlan = async () => {
    const cipId = patientId;
    const status = 0;

    const storedUser = JSON.parse(localStorage.getItem("user"));
    const employeeId = storedUser?.employee;

    const body = {
      cipId,
      status,
      employeeId,
      standardCarePlanIds,
    };

    try {
      const response = await createFullCarePlan(body);
      console.log("✅ Care Plan creado con éxito:", response);
      alert("Care Plan creado exitosamente.");
      const carePlanId = response.patientCarePlanId;
      localStorage.setItem("currentCarePlanId", carePlanId);

      diagnosesRef.current?.resetDiagnoses();

      if (onCreatePlan) onCreatePlan();
    } catch (error) {
      console.error("❌ Error al crear Care Plan:", error);
      alert("Hubo un error al crear el Care Plan.");
    }
  };


  return (
    <Box sx={{ width: "100%", mt: 4, p: 3 }}>
      <Grid container spacing={3}>
        {/* Sección de Información del Paciente */}
        <Grid item xs={12} md={4}>
        <PatientInformation patientId={patientId} onOpenModal={onOpenModal} />
        </Grid>

        {/* Sección de Diagnósticos, Alergias y Hábitos */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Diagnoses ref={diagnosesRef} setStandardCarePlanIds={setStandardCarePlanIds} />
            </Grid>
            <Grid item xs={12}>
              <Allergies />
            </Grid>
            <Grid item xs={12}>
              <Habits />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Botón para Crear Care Plan */}
      <Box sx={{ mt: 3, textAlign: "right" }}>
        <Button variant="contained" onClick={handleCreatePlan}>
        {t("CarePlan.createCarePlan")}
        </Button>
      </Box>
    </Box>
  );
}
